import Button from "react-bootstrap/Button";
import Card from "react-bootstrap/Card";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import Badge from "react-bootstrap/Badge";
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import Header from "../components/Header";
import { getLanguage } from "../helpers/LanguageTranslation";
import {
  FaWhatsapp,
  FaArrowRotateLeft,
  FaRegCalendar,
  FaRegClock,
  FaLocationDot,
  FaRegUser
} from "react-icons/fa6";
import { IoLanguage } from "react-icons/io5";
import { useState, useEffect } from "react";
import { postDataHelper } from "../requests/PostRequests";

import CardBody from "react-bootstrap/esm/CardBody";
import CardText from "react-bootstrap/esm/CardText";
import CardTitle from "react-bootstrap/esm/CardTitle";
import CardSubtitle from "react-bootstrap/esm/CardSubtitle";
import NavBar from "../components/NavBar";

const ClassContent = ({ course, onTriggerFlip }) => {
  const [classes, setClasses] = useState([]);

  // Fetch entries from the server
  const getClasses = async (courseId) => {
    const onSuccess = (data) => {
      let newClasses = [];
      const rows = data.result.rows;
      const length = rows.length;

      for (let i = 0; i < length; i++) {
        newClasses.push({
          course_id: parseInt(rows[i].course_id),
          name: rows[i].name,
          address: rows[i].address,
          postal: rows[i].postal,
          start_date: rows[i].start_date,
          end_date: rows[i].end_date,
          language: rows[i].language,
          number_of_sessions: rows[i].number_of_sessions
        });
      }

      setClasses(newClasses);
    };

    // Get classes based on the courseId
    await postDataHelper("/v1/classes",
      { courseId: courseId },
      (title, content, type) => console.log(`${title}, ${content}, ${type}`),
      onSuccess);
  };

  // Run once and load all the classes related to this course
  useEffect(() => {
    async function fetchData() {
      await getClasses(course.id);
    }

    fetchData();
  }, []);

  return (
    <>
      {/* <Button
        variant="custom-secondary top"
        onClick={() => onTriggerFlip(course.id)}
      >
        Back
      </Button> */}
      <Button variant="link" className="class-card-back-btn">
        <FaArrowRotateLeft
          onClick={() => onTriggerFlip(course.id)}
          className="class-card-back-arrow-icn"
        />
      </Button>
      <div className="class-card-header">
        <CardTitle
          style={{ margin: "4px 0px", color: "var(--text-dark-color)" }}
        >
          {course.name}
        </CardTitle>
        <CardSubtitle
          style={{
            marginTop: "8px",
            color: "var(--text-color)",
            fontSize: "1.1em",
          }}
        >
          <b>Course Code:</b> {course.course_code}
        </CardSubtitle>
      </div>
      <span className="horz-line"></span>
      {classes.length > 0 ? (
        classes.map(function (c, i) {
          /*
            NOTE: start_date and end_date values contains class date range (date part) and class timing (time part)
           */
          const startDateFormatted = new Date(c.start_date).toLocaleDateString(
            "en-sg",
            { year: "numeric", month: "short", day: "numeric" }
          );
          const endDateFormatted = new Date(c.end_date).toLocaleDateString(
            "en-sg",
            { year: "numeric", month: "short", day: "numeric" }
          );
          const startTimeFormatted = new Date(c.start_date).toLocaleTimeString(
            "en-us",
            { hour: "2-digit", minute: "2-digit" }
          );
          const endTimeFormatted = new Date(c.end_date).toLocaleTimeString(
            "en-us",
            { hour: "2-digit", minute: "2-digit" }
          );
          const langFormatted = getLanguage(c.language);

          return (
            <div>
              <CardBody>
                <CardText>
                  <FaRegCalendar className="class-icn" /> {startDateFormatted}{" "}
                  - {endDateFormatted}
                </CardText>
                <CardText>
                  <FaRegClock className="class-icn" /> {startTimeFormatted}-
                  {endTimeFormatted} ({c.number_of_sessions} session{c.number_of_sessions > 1 ? 's' : ''})
                </CardText>
                <CardText>
                  <FaLocationDot className="class-icn" /> {c.address}{" "}
                  {c.postal}
                </CardText>
                <CardText>
                  <IoLanguage className="class-icn" /> {langFormatted}
                </CardText>
                <CardText>
                  <FaRegUser className="class-icn" /> {c.name}
                </CardText>
                <div className="class-enquire-btn btn-whatsapp">
                  <FaWhatsapp className="whatsapp-icon" />
                  <a href="/">Enquire Now</a>
                </div>
              </CardBody>
              {classes.length - 1 !== i ? <span className="horz-line" style={{ display: "block" }}></span> : <></>}
            </div>
          );
        })
      ) : (
        <CardBody>
          <CardText>No classes available now, check back again!</CardText>
        </CardBody>
      )}
    </>
  );
};

const CardContent = ({ course, flags, onTriggerFlip }) => {
  return !flags[course.id] ? (
    <>
      <Card.Img
        variant="top"
        src={course.image_url}
        alt="Card image"
        style={{ height: "15vw" }}
      />
      <Card.Body>
        <Card.Title>{course.name}</Card.Title>
        <Card.Text>
          {course.tags.map(function (c, _) {
            return (
              <Badge
                bg="custom-primary"
                style={{ padding: "3px 8px", margin: "3px" }}
                pill={true}
              >
                {c.tag}
              </Badge>
            );
          })}
        </Card.Text>
        <Card.Text>{course.description}</Card.Text>
      </Card.Body>
      <Button
        variant="custom-secondary bottom"
        onClick={() => onTriggerFlip(course.id)}
        style={{ margin: "10px" }}
      >
        Available Classes
      </Button>
    </>
  ) : (
    <ClassContent course={course} onTriggerFlip={onTriggerFlip} />
  );
};

const DisplayCards = ({ courses, flags, onTriggerFlip }) => {
  let minHeight = 30;
  const maxLength = Math.max(
    ...courses.map((course) => course.description.length)
  );
  const maxLengthPerLine = 30;
  const numOfLines = maxLength / maxLengthPerLine;
  const height = `${numOfLines + minHeight}rem`;

  return courses.map(function (course, idx) {
    return (
      <Col key={idx}>
        <Card
          key={`card_${idx}`}
          border="muted"
          style={{
            height: height,
            margin: "10px",
            overflow: "auto",
          }}
        >
          <CardContent
            course={course}
            flags={flags}
            onTriggerFlip={onTriggerFlip}
          />
        </Card>
      </Col>
    );
  });
};

const Courses = () => {
  const [courseFlags, setCourseFlags] = useState({});
  const [courses, setCourses] = useState([]);
  const [selectedLang, setSelectedLang] = useState("en");

  function onTriggerFlip(courseId) {
    courseFlags[courseId] = !courseFlags[courseId];
    setCourseFlags(Object.create(courseFlags));
  }

  async function getCourses(language) {
    const onSuccess = (data) => {
      let newCourses = [];
      let newCourseFlags = {};
      const rows = data.result.rows;
      const length = rows.length;

      for (let i = 0; i < length; i++) {
        let tags = [];
        const tagsLength = rows[i].tags.length;
        for (let j = 0; j < tagsLength; j++) {
          tags.push({
            tag: rows[i].tags[j].tag,
            index: rows[i].tags[j].index,
          });
        }

        newCourses.push({
          id: parseInt(rows[i].id),
          course_code: rows[i].course_code,
          name: rows[i].name,
          description: rows[i].description,
          image_url: rows[i].image_url,
          tags: tags,
        });
      }

      newCourses.forEach(function (course) {
        newCourseFlags[course.id] = false;
      });

      setCourses(newCourses.sort((a, b) => a.id - b.id));
      setCourseFlags(newCourseFlags);
    };

    await postDataHelper("/v1/courses",
      { language: language },
      (title, content, type) => console.log(`${title}, ${content}, ${type}`),
      onSuccess);
  }

  useEffect(() => {
    async function fetchData() {
      await getCourses(selectedLang);
    }

    fetchData();
  }, []);

  async function onTriggerChangeLang(newLang) {
    setSelectedLang(newLang);
    await getCourses(newLang);
  }

  return (
    <div className="container-content-fixed">
      <div className="courses-hdr-grp">
        <NavBar />
        <Header title="Courses" />
        <OverlayTrigger
          key={"left"}
          placement={"left"}
          overlay={
            <Tooltip id={`tooltip-left`}>
              Click to translate!
            </Tooltip>
          }
        >
          <Button variant="light" className="courses-translate-btn" onClick={() => onTriggerChangeLang(selectedLang == "en" ? "zh" : "en")}>
            <IoLanguage className="courses-translate-icn" />
            <span className="courses-translate-lang">{getLanguage(selectedLang)}</span>
          </Button>
        </OverlayTrigger>
      </div>
      <Row xs={1} md={2} lg={3} className="g-3">
        <DisplayCards
          courses={courses}
          flags={courseFlags}
          onTriggerFlip={onTriggerFlip}
        />
      </Row>
    </div>
  );
};

export default Courses;
